











































































































import {Component, Prop, Vue} from "vue-property-decorator";
import LineChart from "@/components/studio/_chart.vue";
import _ from 'lodash';
import MetaSetting from "@/script/metaSetting";

@Component({
    components: {LineChart}
})
export default class Dashboard extends Vue {
    metaSetting !: MetaSetting;

    projects: any[] = [];
    selectedProject: any = '';
    selectedDate: any = 'today';

    playCnt: number = 0;
    likeCnt: number = 0;

    gameList: any[] = [];
    // :options="['기간', '지난 30일', '지난 7일', '지난 6개월', '올해 (2021)', '작년 (2020)', '저번달', '이번달', '오늘']"

    dataOptions = [
        {name: '오늘', date: 'today'}, {name: '지난 7일', date: '7'}, {name: '지난 30일', date: '30'}];

    async mounted() {
        await this.$store.dispatch("loginState");
        this.createMetaSetting();
        this.gameListFetch();
        this.playCount();
    }

    createMetaSetting(){
        this.metaSetting = new MetaSetting({
            title: `${this.$t('dashboard')} | Zempie.com`
            ,meta: [
                {name: 'description', content: `${this.$t('dashboard.desc')}`},
                {property: 'og:url', content: `${this.$store.getters.homeUrl}/${this.$i18n.locale}/dashboard`},
                {property: 'og:title', content: `${this.$t('dashboard')} | Zempie.com`},
                {property: 'og:description', content: `${this.$t('dashboard.desc')}`},
            ]
        });
    }

    playCount() {

        //
        //
        //
        //
        // const arr = [1, 2, 3];
        //
        // const result = arr.reduce(function add(sum, currValue) {
        //     return sum + currValue;
        // }, 0);

    }

    gameListFetch() {
        this.$api.projectList()
            .then((res: any) => {
                this.projects = res;
                this.selectedProject = res[0].gameId;

                this.playCnt = _.reduce(this.projects, function add(sum, currValue) {
                    return sum + currValue.game.count_start;
                }, 0)

                this.likeCnt = _.reduce(this.projects, function add(sum, currValue) {
                    return sum + currValue.game.count_heart;
                }, 0)

                this.gameList = _.map(this.projects, project => {
                    return {label: project.name, id: project.id};
                })

                console.log('gameList', this.gameList)

            });
    }

}
